import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { MaptilerLayer, Language } from "@maptiler/leaflet-maptilersdk";


const TravelMap = () => {
	const container = document.getElementById("map");
	if (!container) return;

	const mapOptions = {
		zoomControl: true,
		dragging: true,
		doubleClickZoom: false,
		scrollWheelZoom: false,
		keyboard: false,
	};


	const leafletMap = L.map(container, mapOptions).setView([0, 0], 2);

	const layer = new MaptilerLayer({
		apiKey: "KG88Zq7VVjuhhus1b2Ji",
		language: Language.FRENCH,
		style: "https://api.maptiler.com/maps/base-v4/style.json?key=ZIB2OGfW1FztWum75Bci"
	});

	layer.addTo(leafletMap);

	const myIcon = L.divIcon({
		html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 85"><path d="M31.75 0C48.318 0 61 12.488 61 29.057V30c0 21.834-19.322 49-29.75 55H31C20.572 79 0 51.834 0 30v-.943C0 12.488 13.932 0 30.5 0h1.25z"/><path d="M31.688 2C47.428 2 59 13.989 59 29.729v.896C59 51.367 41.119 77 31.212 83h-.237C21.069 77 2 51.367 2 30.625v-.896C2 13.989 14.76 2 30.5 2h1.188z"/></svg>`,
		iconAnchor: [9, 25],
		iconSize: [18, 25],
	});

	const mapMarkers = container.getAttribute("data-markers");
	if (!mapMarkers) return;

	let coordinates;
	try {
		coordinates = JSON.parse(mapMarkers);
	} catch (e) {
		console.error("data-markers : JSON invalide", e);
		return;
	}

	if (!Array.isArray(coordinates) || !coordinates.length) return;

	const latLngs = [];

	coordinates.forEach((coord) => {
		if (
			!Array.isArray(coord) ||
			coord.length < 3 ||
			typeof coord[0] !== "number" ||
			typeof coord[1] !== "number"
		)
			return;

		const popupEl = document.createElement("span");
		popupEl.innerHTML = coord[2];

		L.marker([coord[0], coord[1]], { icon: myIcon })
			.bindPopup(popupEl)
			.addTo(leafletMap);

		latLngs.push([coord[0], coord[1]]);
	});

	if (latLngs.length === 0) return;

	if (latLngs.length === 1) {
		leafletMap.setView(latLngs[0], 13);
	} else {
		L.polyline(latLngs, { color: "#969696" }).addTo(leafletMap);
		leafletMap.fitBounds(L.latLngBounds(latLngs), { padding: [50, 50] });
	}
};

export { TravelMap };
